/*
*@/components/request/invite-new-providers
*/
export default {
  inviteNewProviders: {
    title: 'Invitar nuevos proveedores',
    steps: {
      title1: 'Proveedores',
      description1: 'Selecciona los proveedores que vas a invitar',
      title2: 'Ítem',
      description2: 'Selecciona la descripción del ítem',
      title3: 'Resumen',
    },
    validation1: {
      label1: 'Nombre del proveedor',
      content1: 'Puede ingresar el nombre del proveedor o seleccionar desde los proveedores ya registrados en CAT4MRO',
      placeholder1: 'Ingrese o seleccione el nombre del proveedor',
    },
    validation2: {
      label1: 'Rut del Proveedor',
      placeholder1: 'Ingrese el rut del proveedor',
    },
    validation3: {
      label1: 'Nombre de Contacto',
      placeholder1: 'Ingrese el nombre de contacto',
    },
    validation4: {
      label1: 'Email de Contacto',
      placeholder1: 'Ingrese el email de contacto',
    },
    divider: 'Agregar proveedor',
    table1: {
      column1: {
        p1: 'Nombre de Contacto:',
        p2: 'Email de Contacto:',
      },
      column2: {
        label1: 'Nombre',
      },
      column3: {
        label1: 'Rut',
      },
      column4: {
        label1: 'Registrado',
        option1: 'Sí',
        option2: 'No',
      },
    },
    info_alert: 'Aún no se han agregado proveedores',
    validation5: {
      content: 'Descripción con la que el proveedor identificará el ítem que usted necesita',
      label: 'Descripción del ítem',
    },
    template1: {
      from: 'De:',
      to: 'Para:',
      button: 'Proveedores',
      table: {
        column1: {
          p1: 'Nombre de Contacto:',
          p2: 'Email de Contacto:',
        },
        column2: {
          label: 'Nombre',
        },
        column3: {
          label: 'Rut',
        },
        column4: {
          label: 'Registrado',
          span1: 'Sí',
          span2: 'No',
        },
      },
    },
    label: 'Descripción del Ítem:',
    back_button: 'Atrás',
    forward_button: 'Siguiente',
    loading_send: 'Enviando solicitudes...',
    send_requests: 'Enviar Solicitudes',
    script: {
      methods: {
        handleAddNewOrganization: {
          notify: {
            title: 'Agregar proveedor',
            message: 'Este proveedor ya se encuentra invitado a la solicitud de información.',
          },
        },
        handleSendRequests: {
          confirm: {
            title1: '¿Está seguro de invitar a estos proveedores?',
            title2: 'Precaución',
            confirm_button: 'Si, Envíar',
            cancel_button: 'No, Cancelar',
            notify: {
              title: 'Solicitud de Información',
              message: 'Solicitudes de información enviadas correctamente',
            },
          },
          cancel: {
            notify: {
              title: 'Solicitud de Información',
              message: 'La solicitud de información no ha sido enviada.',
            },
          },
        },
        handleNextStep: {
          notify: {
            title: 'Seleccionar Proveedores',
            message: 'Debe agregar al menos un proveedor para continuar',
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/request_information/components/inviteNewProviders.js